import { addMinutes } from 'date-fns';
import { DateTime } from 'luxon';

export const LUXON_DATE_FORMAT = 'LL/dd/yyyy';
export const LUXON_DATE_FROM_FORMAT = 'yyyy-MM-dd';
/**
 *
 * @param jsonDate
 * @returns Date object accounting for offsets.
 * Certain dates aren't stored with TZ information (just as a ruby date), so they're coming down without a TZ offset.
 * Therefore, when they are displayed, it converts to local time, changing the date. This is not what we want.  So we
 * need to change the date to add the current UTC offset, which will then allow the date to be in "local time" and the
 * system will display it correctly.
 */
export function toLocalDate(jsonDate) {
  const n = jsonDate && new Date(jsonDate);
  return n && addMinutes(n, n.getTimezoneOffset());
}

/**
 *
 * @param date a Date object
 * @param timeZone
 * @returns DateTime object.
 * Certain dates aren't stored with TZ information (e.g. DOB, Date of service),
 * so they're coming down without a TZ offset e.g. 2021-12-16.
 * Therefore, when they are passed to Date object, it converts to local time, changing the date.
 * But the local date is already in User's timezone,
 * So this method will create same DateTime object without changing the date time
 * which will then allow the date to be in correct local time and the system will display it correctly.
 */
export function toTimeZoneDateTime(date: Date, timeZone: string): DateTime {
  // getMonth() returns the month (0 to 11) of a date, so added 1.
  return DateTime.local(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    { zone: timeZone }
  );
}

/**
 *
 * @param date a Date object
 * @param timeZone
 * @returns Date object.
 * Will return a date with the timezone property set to the user's profile timezone.
 */
export function toUserTimeZoneDate(date: Date, timeZone: string): Date {
  const userTzDateString = date.toLocaleString('en-US', { timeZone });
  return new Date(userTzDateString);
}
